import * as React from 'react';

import {ActivityRow} from 'shells/row/activity-row/activity-row';

import type {GetActivitiesForWidget_activities as Activity} from 'nutshell-graphql-types';

import {appHistory} from '../../../../../history';

import {getMappedParticipants} from '../helpers';

type Props = {
    activities: Activity[] | null | undefined;
};

export function ActivitiesList(props: Props) {
    if (!props.activities || props.activities.length === 0) {
        return null;
    }

    return (
        <>
            {props.activities
                .filter((activity) => activity && activity.activityType)
                .map((activity) => (
                    <ActivityRow
                        key={activity.id}
                        title={activity.name}
                        activityTypeIconId={activity.activityType.icon}
                        participants={getMappedParticipants(activity.participants)}
                        startTime={activity.startTime}
                        endTime={activity.endTime}
                        isAllDay={activity.isAllDay}
                        isOverdue={activity.isOverdue}
                        onClick={() => {
                            appHistory.replace({
                                ...appHistory.location,
                                hash: `/${activity.id}`,
                                state: {modal: true},
                            });
                        }}
                        isPrivate={activity.isPrivate}
                    />
                ))}
        </>
    );
}
